import React from "react";

function SvgIcMapPoi061(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22 11a1 1 0 110-2 1 1 0 010 2zm-8.986.28c.028.69.152 1.352.365 1.976C10.812 13.776 9 15.03 9 16.5c0 1.933 3.134 3.5 7 3.5 3.21 0 5.91-1.08 6.734-2.555a7.03 7.03 0 003.132-2.633C26.518 15.71 27 17.016 27 18c0 1.184-.699 2.841-1.552 3.68 0 0-3.372 3.32-9.448 3.32-5.828 0-9.169-3.054-9.432-3.304l-.017-.016c-.853-.839-1.55-2.496-1.55-3.68 0-1.185.697-2.84 1.55-3.68 0 0 2.28-2.24 6.463-3.04zM20 6c2.234 0 4.103 1.475 4.744 3.496L27 11l-2.256 1.504C24.103 14.525 22.234 16 20 16a5 5 0 010-10z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi061;
